import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { defineMessages } from '../../i18n/define';
import { useT } from '../../i18n/hooks';
import { Icon } from './Icon';

const m = defineMessages({
  label: {
    id: 'common.ui.levelTrail.label',
    defaultMessage: 'Уровни',
    description: 'aria-label цепочки «район → массив → хозяйство → контур» над страницей (хлебные крошки)',
  },
});

export interface TrailStep {
  /** Ступень называет свой уровень: «МАССИВ», «ХОЗЯЙСТВО». */
  level: string;
  name: string;
  /** Адрес ступени. У последней ступени игнорируется. */
  to?: string;
}

/**
 * Жест «наверх». Последняя ступень не ссылка — на неё уже смотрят.
 * Возврат в СПИСОК с его фильтрами — отдельная кнопка в строке действий,
 * это другой вопрос.
 */
export function LevelTrail({ steps }: { steps: TrailStep[] }) {
  const t = useT();
  if (steps.length === 0) return null;

  return (
    <nav className="trail" aria-label={t(m.label)}>
      {steps.map((step, i) => {
        const last = i === steps.length - 1;
        return (
          <span className="trail__item" key={`${step.level}-${step.name}-${i}`}>
            {i > 0 ? (
              <span className="trail__sep" aria-hidden="true">
                <Icon icon={ChevronRight} size={16} />
              </span>
            ) : null}
            <span className="trail__level">{step.level}</span>
            {last || !step.to ? (
              <span className="trail__name" title={step.name} aria-current={last ? 'page' : undefined}>
                {step.name}
              </span>
            ) : (
              <Link className="trail__name" to={step.to} title={step.name}>
                {step.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
